import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'

export const useStyles = makeStyles({
  style: {
    [appTheme.breakpoints.down('md')]: {
      padding: '0rem 0.5rem 0rem 0.5rem',
      background: '#F5F5F5',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      borderRadius: 4,
      boxShadow: 'none',
      height: 'auto',
      width: '100%',
      // maxHeight:'40rem',
      minHeight: '25rem'
    },
    '& .rbc-event-content': {
      '& .rbc-event-block': {
        minHeight: '22px',
        '& p': {
          lineHeight: '20px'
        },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
      }
    },
    '& .rbc-agenda-table': {
      '& thead': {
        '& tr': {
          '& th': {
            fontWeight: 500,
            fontSize: '14px !important'
          }
        }
      },
      '& tbody': {
        '& tr': {
          '& td': {
            fontSize: '12px'
          }
        }
      }
    },
    '& .rbc-events-container > *>*': {
      display: 'flex !important',
      justifyContent: 'flex-start !important',
      alignItems: 'center'
    },
    '& .rbc-event': {
      border: '1px solid black',
      display: 'flex !important',
      flexDirection: 'row',
      padding: '0 3px!important'
    }
  }
})
